/** @jsx jsx */
import { jsx } from 'theme-ui';
import Link from '../Link';
import { FooterNavItem as itemStyle } from './Footer.styles';

export default function FooterNavItem({
  slug,
  url,
  href = url,
  title,
  children,
}) {
  return (
    <li sx={itemStyle}>
      {slug || href ? (
        <Link to={slug || href}>{children || title}</Link>
      ) : (
        children || title
      )}
    </li>
  );
}
